import { Component, inject, Input } from '@angular/core';
import { BasicError } from 'projects/shared/lib/error/basic-error';
import { ICartCreationDialogService } from 'shared/services/ui/cart-creation-dialog/cart-creation-dialog-service.abstract';
import { ServiceLocator } from 'projects/shared/lib/services/infrastructure/service-locator.service';
import { ShoppingCartDto, EShoppingCartGetQueryType } from 'projects/shared/lib/services/INTEGRA_Shop_Client';
import { firstValueFrom } from 'rxjs';
import { ICartService, ICartServiceToken } from 'projects/shared/lib/services/data/cart/cart-service.interface';
import { LoggerService } from 'projects/shared/lib/services/infrastructure/logger/logger.service';
import { DeliveryDateComponent } from '../../delivery-date/delivery-date.component';
import { ComponentConfigBase } from '../../../base/config/component-config-base.model';

@Component({
  selector: 'app-cart-preview-info',
  imports: [
    DeliveryDateComponent
  ],
  templateUrl: './app-cart-preview-info.component.html',
  styleUrls: ['./app-cart-preview-info.component.scss']
})
export class CartPreviewInfoComponent {

  private readonly logger: LoggerService;
  private readonly cartDataService: ICartService;

  @Input() public config?: CartPreviewInfoConfig | undefined = new CartPreviewInfoConfig();

  public constructor() {
    this.logger = inject(LoggerService);
    this.cartDataService = inject(ICartServiceToken);
  }

  public async cartCreationDialogShowAsync(cart?: ShoppingCartDto | undefined, isCartCreation: boolean | undefined = true) {
    if (cart == undefined) {
      // try looking for an "old" one
      await firstValueFrom(this.cartDataService.cartGet(EShoppingCartGetQueryType.GetLatestOrCreateNew, false)).then((result) => {
        cart = result.shoppingCart;
      }).catch((error) => {
        this.logger.error(error, this.constructor.name);
        let errorMessage = $localize`:@@CartPreviewCreateCartErrorMessage:Could not create cart`;
        throw new BasicError(errorMessage, JSON.parse(error.response).errorCode);
      });
    }
    ServiceLocator.injector.get(ICartCreationDialogService).cartCreationDialogShow(
      () => { },
      cart,
      isCartCreation
    );
  }

}

export class CartPreviewInfoConfig extends ComponentConfigBase<CartPreviewInfoConfig> {
  public cart?: ShoppingCartDto | undefined;
  /** Specifies whether the title should be displayed or not. Default = true */
  public displayHeaderTitle?: boolean | undefined;

  constructor(data?: Partial<CartPreviewInfoConfig>) {
    super(data);
  }

  public setFallbackDefaults(): void {
    this.displayHeaderTitle ??= true;
  }
}
